import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import SectionHeader from '../components/SectionHeader';
import ServiceCard from '../components/cards/ServiceCard';
import GoldButton from '../components/GoldButton';
import { Factory, Building2, Anchor, HardHat, Truck, Droplets, Hammer, Construction } from 'lucide-react';

const Services = () => {
  return (
    <Layout>
      <PageHeader 
        title="Our Services" 
        subtitle="End-to-End Civil, Structural & Specialized Ground Engineering"
        image="https://images.unsplash.com/photo-1624027492684-327af1fb7559?q=80&w=2070&auto=format&fit=crop"
      />

      {/* Overview */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <p className="text-xl text-muted-foreground leading-relaxed" data-aos="fade-up">
            TOTO INFRA is an integrated civil and infrastructure service provider. We combine specialized ground engineering expertise with large-scale turnkey construction capabilities to deliver complex projects under one roof.
          </p>
        </div>
      </section>

      {/* Core Services */}
      <section className="py-24 bg-card">
        <div className="container mx-auto px-4">
          <SectionHeader title="Core Competencies" subtitle="Specialized Services" />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard 
              title="Steel & Power Plant Construction" 
              description="Comprehensive civil works for Blast Furnaces, SMS, Rolling Mills, and Power Plants. Expertise in heavy industrial foundations."
              icon={Factory}
            />
            <ServiceCard 
              title="Turnkey Civil Construction" 
              description="End-to-end project execution including planning, design, procurement, and construction for industrial and commercial sectors."
              icon={Building2}
            />
            <ServiceCard 
              title="Post Tensioning & Rock Anchoring" 
              description="Specialized PT solutions for long-span structures and rock anchoring for slope stabilization and uplift resistance."
              icon={Anchor}
            />
            <ServiceCard 
              title="Piling & Foundations" 
              description="Execution of all types of piles (Bored, Driven, Micro) and deep foundation systems for challenging soil conditions."
              icon={HardHat}
            />
            <ServiceCard 
              title="Soil Stabilization" 
              description="Ground improvement techniques including Vibro Stone Columns and dynamic compaction to enhance soil bearing capacity."
              icon={Construction}
            />
            <ServiceCard 
              title="RMC Solutions" 
              description="High-quality Ready Mix Concrete supply with automated batching plants and transit mixers for large-scale pours."
              icon={Truck}
            />
          </div>
        </div>
      </section>

      {/* Civil & Structural */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-4">
          <SectionHeader title="Civil & Structural Works" subtitle="Building The Framework" />
          <div className="grid md:grid-cols-2 gap-12">
            <div data-aos="fade-right">
              <h3 className="text-2xl font-serif font-bold text-primary mb-6">Structural Excellence</h3>
              <ul className="space-y-4">
                {['PCC & RCC Works', 'Industrial Building Construction', 'Commercial Complexes', 'Road Construction & Pavements', 'Earth Filling & Grading', 'Landscaping & Hardscaping'].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-muted-foreground border-b border-white/5 pb-3">
                    <Hammer size={18} className="text-primary" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div data-aos="fade-left">
              <h3 className="text-2xl font-serif font-bold text-primary mb-6">Utilities & Support</h3>
              <ul className="space-y-4">
                {['Water Supply Systems', 'Fire Fighting Networks', 'Storm Water Drainage', 'Sewerage Treatment Plants', 'Electrical Ducting', 'Industrial Piping Support'].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-muted-foreground border-b border-white/5 pb-3">
                    <Droplets size={18} className="text-primary" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* RMC CTA */}
      <section className="py-20 bg-card border-y border-primary/20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-serif font-bold text-white mb-6">Need High-Grade Concrete?</h2>
          <p className="text-muted-foreground mb-8 max-w-2xl mx-auto">
            Our dedicated RMC division ensures consistent quality and timely delivery for your critical pours.
          </p>
          <GoldButton>Visit RMC Division</GoldButton>
        </div>
      </section>
    </Layout>
  );
};

export default Services;
